import React, { useState } from 'react';
import ButtonComp from '../../../atoms/Buttons/Presentation/ButtonComp';
import { InputBox } from '../../../atoms/InputBox';
import LOYALTYCRM_SIGNUP_CONSTANT, {
  SIGN_UP_EMAIL_REGEX,
  SUBSCRIBE_TO_LOYALTY,
  SUCCESSFUL,
  UNSUCCESSFUL,
} from '../Constants/LoyaltyCrmSignupComponentConstant';
import { setLoyaltyCrmAnalyticsData } from '../LoyaltyCrmUtilities/loyaltyCrmUtils';

export const LoyaltyCrmItems = props => {
  const { contentData = {} } = props;
  const [emailValue, setEmailValue] = useState('');
  const onChangeHandler = e => {
    setEmailValue(e.target.value);
  };
  const clickHandler = value => {
    const emailRegexString = SIGN_UP_EMAIL_REGEX;
    value && emailRegexString.test(String(value).toLowerCase())
      ? setLoyaltyCrmAnalyticsData({
          event: SUBSCRIBE_TO_LOYALTY,
          subscribe: SUCCESSFUL,
        })
      : setLoyaltyCrmAnalyticsData({
          event: SUBSCRIBE_TO_LOYALTY,
          subscribe: UNSUCCESSFUL,
        });
  };
  const onClickHandler = e => {
    e.preventDefault();
    clickHandler(emailValue);
  };

  const { email = '', headline = '', subHeadline = '', mobileSrc = '', desktopSrc = '', buttonText = '' } = contentData;
  return (
    <div className='loyalty-crm'>
      <picture>
        <source
          media={LOYALTYCRM_SIGNUP_CONSTANT.DESKTOP_MAX_WIDTH}
          srcSet={mobileSrc}
          alt={''}
          className='loyalty-img'
        />
        <img src={desktopSrc} alt={''} className='loyalty-img' />
      </picture>
      <div className='loyalty-content'>
        <div className='loyalty-headline'>{headline}</div>
        <div className='loyalty-subheadline'>{subHeadline}</div>
        <form className='loyalty-email' onSubmit={onClickHandler}>
          <div className='loyalty-mailbox'>
            <InputBox placeholder={email} onChange={onChangeHandler} value={emailValue} data-testid='loyalty-input' />
          </div>
          <ButtonComp
            className='button blackButton loyalty-button'
            data-testid='loyalty-submit'
            aria-label={buttonText}
          >
            {buttonText}
          </ButtonComp>
        </form>
      </div>
    </div>
  );
};
export default LoyaltyCrmItems;
